import React, { createRef } from "react";
import EditPieceStepAddButton from "./editPieceStepAddButton";

interface EditPieceStepFileUploadButtonProps {
    children: any;
    onUpload: (files: File[]) => void;
    accept: string[];
}

export default function EditPieceStepFileUploadButton(props: EditPieceStepFileUploadButtonProps) {

    const inputFile = createRef<HTMLInputElement>();

    const handleFileUpload = (e: any) => {
        e.preventDefault();
        const { files } = e.target;
        if (files && files.length) {
            props.onUpload(files);
        }
      };

    return <EditPieceStepAddButton onClick={() => {
        inputFile.current?.click();
    }}>
        <input
            accept={props.accept.map(format => `.${format}`).join(",")}
            style={{ display: "none" }}
            // accept=".zip,.rar"
            ref={inputFile}
            onChange={handleFileUpload}
            type="file"
        />
        {props.children}
    </EditPieceStepAddButton>
}